import jwt_decode from "jwt-decode";
import { useEffect, useRef } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import PrivateRoute from "./components/common/PrivateRoute";
// Pages
import Axios from "axios";
import CustomModal from "./components/common/CustomModal/CustomModal";
import CustomModal2 from "./components/common/CustomModal/CustomModal2";
import MenuLateral from "./components/common/layout/MenuLateral/MenuLateral";
import Notifications from "./components/common/Notifications/Notifications";
import RoleStyle from "./components/common/layout/RoleStyle";
import LeftPanel from "./components/common/LeftPanel/LeftPanel";
import Loader from "./components/common/Loader";
import SidePanel from "./components/common/SidePanel/SidePanel";
import ActivateAccount from "./components/pages/ActivateAccount/ActivateAccount";
import AnomalyList from "./components/pages/AnomalyList/AnimalyList";
import CalendarDetail from "./components/pages/CalendarDetail/CalendarDetail";
import CERData from "./components/pages/CERData/CERData";
import AmendmentPrint from "./components/pages/CERPrint/AmendmentPrint";
import CERPrint from "./components/pages/CERPrint/CERPrint";
import ConstantDynamic from "./components/pages/ConstantDynamic/ConstantDynamic";
import Dashboard from "./components/pages/Dashboard/Dashboard";
import EntretienGiratoire from "./components/pages/EntretienGiratoire/EntretienGiratoire";
import AllInvitations from "./components/pages/EP/AllInvitations/AllInvitations";
import EP from "./components/pages/EP/EP";
import EpForm from "./components/pages/EP/EpForm/EpForm";
import EpPv from "./components/pages/EP/EpPv/EpPv";
import EpPvV2 from "./components/pages/EP/EpPv/EpPvV2";
import EpSessionV2Page from "./components/pages/EP/EpSessionV2/EpSessionV2Page";
import MyEps from "./components/pages/EP/MyEps/MyEps";
import DemandesSuspensionRemobilisation from "./components/pages/SuspensionRemobilisation/DemandesSuspensionRemobilisation";
import Sectors from "./components/pages/EP/Sectors/Sectors";
import FileExchange from "./components/pages/FileExchange/FileExchange";
import ImportDetail from "./components/pages/Imports/ImportDetail";
import ImportList from "./components/pages/Imports/ImportList";
import SanctionsFTPage from "./components/pages/SanctionsFT/SanctionsFTPage";
import ExportDetail from "./components/pages/Exports/ExportDetail";
import ExportList from "./components/pages/Exports/ExportList";
import Maquettes from "./components/pages/Maquettes";
import MyAnomalyList from "./components/pages/MyAnomalyList/MyAnomalyList";
import NotFound from "./components/pages/NotFound/NotFound";
import OperateurDetail from "./components/pages/Operateurs/OperateurDetail";
import MaStructure from "./components/pages/Operateurs/MaStructure";
import FicheCompteOperateur from "./components/pages/Operateurs/FicheCompteOperateur";
import ReglesSousOrientation from "./components/pages/ReglesSousOrientation/ReglesSousOrientationPage";
import {
  OperateursAccompagnement,
  RepertoireOperateurs,
} from "./components/pages/Operateurs/OperateurList";
import OrganizationDetail from "./components/pages/OrganizationDetail/OrganizationDetail";
import OrganizationList from "./components/pages/OrganizationList/OrganizationList";
import PassOrientation from "./components/pages/PassOrientation/PassOrientation";
import Profile from "./components/pages/Profile/Profile";
import RdvComponent from "./components/pages/RdvComponent/RdvComponent";
import RecipientCreate from "./components/pages/RecipientCreate/RecipientCreate";
import RecipientCreateEP from "./components/pages/RecipientCreateEP/RecipientCreateEP";
import RecipientCreateEpDetail from "./components/pages/RecipientCreateEpDetail/RecipientCreateEpDetail";
import RecipientCreateEpList from "./components/pages/RecipientCreateEpList/RecipientCreateEpList";
import RecipientDetail from "./components/pages/RecipientDetail/RecipientDetail";
import RecipientList from "./components/pages/RecipientList/RecipientList";
import RecipientTempDetail from "./components/pages/RecipientTempDetail/RecipientTempDetail";
import RecipientTempList from "./components/pages/RecipientTempList/RecipientTempList";
import RenewPassword from "./components/pages/RenewPassword/RenewPassword";
import Reorientations from "./components/pages/Reorientations/Reorientations";
import Simulator from "./components/pages/Simulator/Simulator";
import SiteDetail from "./components/pages/SiteDetail/SiteDetail";
import SiteList from "./components/pages/SiteList/SiteList";
import Stats from "./components/pages/Stats/Stats";
import ThemeDetail from "./components/pages/ThemeDetail/ThemeDetail";
import ThemeList from "./components/pages/ThemeList/ThemeList";
import UserDetail from "./components/pages/UserDetail/UserDetail";
import UserList from "./components/pages/UserList/UserList";
import { api_url } from "./config";
import { authActions } from "./context/actions/authActions";
import { constantActions } from "./context/actions/constantActions";
import { AUTH_TYPES } from "./context/reducers/authReducers";
import useStore from "./context/useStore";
import sidenavItems from "./sidenavItems";

import { Settings } from "luxon";
import AllRecipients from "./components/pages/AllRecipients/AllRecipients";
import CERList from "./components/pages/CERList/CERList";
import OrientationJobList from "./components/pages/OrientationJobList/OrientationJobList";
import RDOInvite from "./components/pages/RDOInvite/RDOInvite";
import RecipientStockDetail from "./components/pages/RecipientStockDetail/RecipientStockDetail";
import RecipientStockList from "./components/pages/RecipientStockList/RecipientStockList";
import SuiviAnomalyList from "./components/pages/SuiviAnomalyList/SuiviAnomalyList";
import Test from "./components/pages/Test/Test";
Settings.defaultZoneName = "Indian/Reunion";

// Cookie de session httpOnly : envoyé sur chaque appel API.
Axios.defaults.withCredentials = true;

var firstLoad = true;
const App = () => {
  const [state, dispatch] = useStore();
  var actions = authActions(state, dispatch);
  var c_actions = constantActions(state, dispatch);
  // Intercepteur de session enregistré une seule fois et retiré au démontage
  // (même approche qu'espoar-app). Posé dans le corps du composant, il
  // s'empilait à chaque rendu : une seule réponse refusée déclenchait alors des
  // dizaines d'appels de déconnexion. La référence garde la dernière version
  // de `actions`, recréée à chaque rendu.
  const actionsRef = useRef(actions);
  actionsRef.current = actions;
  useEffect(() => {
    const intercepteur = Axios.interceptors.response.use(
      (response) => response,
      (error) => {
        // Erreur réseau (API injoignable) : pas de réponse, rien à déconnecter.
        const reponse = error.response;
        if (reponse && reponse.status === 401) {
          console.log("UNAUTHORIZED - login out", reponse.config.url);
          if (reponse.config.url !== api_url + "auth/logout") {
            actionsRef.current.logoutUser();
          }
        }
        if (reponse && reponse.status === 400 && reponse.data === "Bad Request") {
          actionsRef.current.logoutUser();
        }
        return Promise.reject(error);
      },
    );
    return () => Axios.interceptors.response.eject(intercepteur);
  }, []);
  useEffect(() => {
    if (localStorage.jwtToken && firstLoad) {
      firstLoad = false;
      // Set auth token header auth
      //tools.setAuthToken(localStorage.jwtToken);
      // Decode token and get user info and exp
      const decoded = jwt_decode(localStorage.jwtToken);

      // Set user and isAuthenticated
      dispatch({
        type: AUTH_TYPES.SET_CURRENT_USER,
        payload: decoded,
      });

      // Check for expired token
      const currentTime = Date.now() / 1000;
      if (decoded.exp < currentTime) {
        // Logout user

        actions.logoutUser();
        // Clear current Profile
        // store.dispatch(clearCurrentProfile())
        // Redirect to login
      }
    }

    if (!localStorage.jwtToken) {
      Axios.get(api_url + "auth/me")
        .then((res) => {
          localStorage.setItem("jwtToken", res.data);

          const decoded = jwt_decode(res.data);
          dispatch({
            type: AUTH_TYPES.SET_CURRENT_USER,
            payload: decoded,
          });
        })
        .catch((err) => {
          //actions.logoutUser();
        });
    }
    c_actions.getConstants();
  }, []);

  return (
    <Router>
      <RoleStyle />
      <Notifications />
      {/* Coquille : grille menu + contenu (menu-lateral.scss) ; les éléments
          hors flux (toasts, styles de rôle) restent en dehors pour ne pas
          occuper de cellule. */}
      <div className="wrapper">
        <MenuLateral items={sidenavItems} />

        <div id="content" className="position-relative">
          {Object.keys(state.constants.items).length ? (
            <Switch>
              <Route path="/login" exact component={Dashboard} />
              <Route
                path="/renew-password/:token/:email"
                exact
                component={RenewPassword}
              />
              <Route
                path="/activate-account/:token/:email"
                exact
                component={ActivateAccount}
              />
              <PrivateRoute path="/" exact component={Dashboard} />
              <PrivateRoute path="/users" exact component={UserList} />
              <PrivateRoute path="/ep" exact component={EP} />
              <PrivateRoute path="/ep/:id" exact component={EpForm} />
              <PrivateRoute
                path="/ep-v2/:id"
                exact
                component={EpSessionV2Page}
              />

              <PrivateRoute path="/ep-v2/:id/pv" exact component={EpPvV2} />
              <PrivateRoute path="/myeps" exact component={MyEps} />
              <PrivateRoute path="/suspension-remobilisation" exact component={DemandesSuspensionRemobilisation} />
              <PrivateRoute
                path="/allepinvitations"
                exact
                component={AllInvitations}
              />
              <PrivateRoute
                path="/createrecipientep"
                exact
                component={RecipientCreateEP}
              />
              <PrivateRoute path="/sectors" exact component={Sectors} />
              <PrivateRoute path="/maquettes" exact component={Maquettes} />
              <PrivateRoute path="/users/:id" exact component={UserDetail} />
              <PrivateRoute
                path="/organizations"
                exact
                component={OrganizationList}
              />
              <PrivateRoute
                path="/organizations/:id"
                exact
                component={OrganizationDetail}
              />
              <PrivateRoute path="/sites" exact component={SiteList} />
              <PrivateRoute path="/sites/:id" exact component={SiteDetail} />
              <PrivateRoute
                path="/sites/:id/calendar"
                exact
                component={CalendarDetail}
              />
              <PrivateRoute path="/rdvs" exact component={RdvComponent} />
              <PrivateRoute
                path="/recipients"
                exact
                component={RecipientList}
              />
              <PrivateRoute
                path="/recipients/:id"
                exact
                component={RecipientDetail}
              />
              <PrivateRoute
                path="/recipients-create"
                exact
                component={RecipientCreate}
              />
              <PrivateRoute path="/anomalies" exact component={AnomalyList} />
              <PrivateRoute
                path="/recipients-ep"
                exact
                component={RecipientCreateEpList}
              />
              <PrivateRoute
                path="/recipients-ep/:id"
                exact
                component={RecipientCreateEpDetail}
              />
              <PrivateRoute
                path="/recipients-temp"
                exact
                component={RecipientTempList}
              />
              <PrivateRoute
                path="/recipients-temp/:id"
                exact
                component={RecipientTempDetail}
              />
              <PrivateRoute
                path="/my-anomalies"
                exact
                component={MyAnomalyList}
              />
              <PrivateRoute
                path="/suivi-anomalies"
                exact
                component={SuiviAnomalyList}
              />
              <PrivateRoute
                path="/anomalies-orientation-ft"
                exact
                component={OrientationJobList}
              />
              <PrivateRoute
                path="/dynamic-constants"
                exact
                component={ConstantDynamic}
              />
              <PrivateRoute path="/themes" exact component={ThemeList} />
              <PrivateRoute path="/themes/:id" exact component={ThemeDetail} />
              <PrivateRoute
                path="/operateurs"
                exact
                component={RepertoireOperateurs}
              />
              <PrivateRoute
                path="/operateurs/accompagnement"
                exact
                component={OperateursAccompagnement}
              />
              {/* Règles de sous-orientation (CE-1419) : avant /operateurs/:id, qui la prendrait pour un opérateur. */}
              <PrivateRoute
                path="/operateurs/regles-sous-orientation"
                exact
                component={ReglesSousOrientation}
              />
              <PrivateRoute
                path="/operateurs/:id"
                exact
                component={OperateurDetail}
              />
              {/* Fiche d'un compte d'opérateur (CE-1407, maquette 10). */}
              <PrivateRoute
                path="/operateurs/:id/comptes/:compteId"
                exact
                component={FicheCompteOperateur}
              />
              {/* Accueil d'un compte d'opérateur d'accompagnement (CE-1407) :
                  la fiche de sa structure, onglet facultatif dans l'adresse. */}
              <PrivateRoute
                path="/ma-structure/:onglet?"
                exact
                component={MaStructure}
              />
              <PrivateRoute path="/eg" exact component={EntretienGiratoire} />
              <PrivateRoute path="/simulator" exact component={Simulator} />
              <PrivateRoute
                path="/file-exchange"
                exact
                component={FileExchange}
              />
              <PrivateRoute
                path="/passorientation/:id"
                exact
                component={PassOrientation}
              />
              <PrivateRoute path="/me" exact component={Profile} />
              <PrivateRoute path="/stats" exact component={Stats} />
              <PrivateRoute
                path="/passorientation"
                exact
                component={PassOrientation}
              />
              <PrivateRoute path="/ep-pv/:id" exact component={EpPv} />
              <PrivateRoute
                path="/reorientations"
                exact
                component={Reorientations}
              />
              <PrivateRoute
                path="/reorientations/:id"
                exact
                component={Reorientations}
              />
              <PrivateRoute path="/cer-data" exact component={CERData} />
              <PrivateRoute
                path="/cercontract/:id"
                exact
                component={CERPrint}
              />
              <PrivateRoute
                path="/ceramendment/:recipientId/:amendmentId"
                exact
                component={AmendmentPrint}
              />
              <PrivateRoute path="/cer-list" exact component={CERList} />
              <PrivateRoute path="/test" exact component={Test} />
              <PrivateRoute
                path="/recipients-stock"
                exact
                component={RecipientStockList}
              />
              <PrivateRoute
                path="/recipients-stock/:id"
                exact
                component={RecipientStockDetail}
              />
              <PrivateRoute
                path="/all-recipients"
                exact
                component={AllRecipients}
              />
              <PrivateRoute path="/invite-rdo" exact component={RDOInvite} />
              <PrivateRoute path="/imports" exact component={ImportList} />
              <PrivateRoute
                path="/imports/:id"
                exact
                component={ImportDetail}
              />
              <PrivateRoute
                path="/sanctions-france-travail"
                exact
                component={SanctionsFTPage}
              />
              <PrivateRoute path="/exports" exact component={ExportList} />
              <PrivateRoute
                path="/exports/:id"
                exact
                component={ExportDetail}
              />
              {/* <PrivateRoute
                path="/recipients-ep-results"
                exact
                component={RecipientEpOutcomeList}
              /> */}
              <Route component={NotFound} />
            </Switch>
          ) : (
            <Loader />
          )}
        </div>
      </div>
      <CustomModal />
      <CustomModal2 />
      <SidePanel />
      <LeftPanel />
    </Router>
  );
};

export default App;
